<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">BIG DATA ENGINE</h4>
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalAdd.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <!-- <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
              class="m__r--5"/> -->
            <b-form-input
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>
    </div>

    <div class="studio-page-content">
      <h4 class="title-tab-experience-manager">DATASET GROUP</h4>
      <b-row v-if="showContainerGroup">
        <b-col
          v-for="(item, index) in listGroup"
          :key="index"
          xl="3"
          lg="4"
          md="4"
          sm="6">
          <div class="data-group-container">
            <div class="d-flex">
              <img
                :src="require('@/assets/icon/joana.svg')"
                width="25"
                @click="openDetail(item.id)">
              <div
                class="data-group-container__label ellipsis"
                @click="openDetail(item.id)">
                {{ item.name }} <br>
                <div class="data-group-container__label-small">
                  Last edit at {{ convertDateTime(item.updated_at) }}
                </div>
              </div>
              <i
                :id="`configPopover-${item.id}`"
                class="fa fa-ellipsis-v fa-lg data-group-container__icon-config"
                @click="showPopoverComponent(item.id)"
              />

              <!-- Popover -->
              <b-popover
                v-click-outside="hideAllPopover"
                v-if="popoverSelected === item.id"
                :target="`configPopover-${item.id}`"
                :show.sync="showPopover"
                triggers="click blur"
                placement="bottom">
                <div
                  class="add-automation"
                  @click="openConfig(item)">Rename</div>
                <div
                  class="add-automation"
                  @click="deleteData(item)">Delete</div>
              </b-popover>
            </div>
            <div
              class="data-group-container__count-dataset"
              @click="openDetail(item.id)">
              {{ item.total_dataset }} <small>dataset</small>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-else
        class="data-group-wrap-loading">
        <b-col
          v-for="i in 8"
          :key="i"
          xl="3"
          lg="4"
          md="4"
          sm="6">
          <div class="group-block" />
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalAdd"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="label-create-form-data">{{ !isUpdate ? 'CREATE' : 'RENAME' }} DATASET GROUP</div>
      <b-form-group :class="{'error-input' : $v.dataset_group_name.$error}">
        <label for="name"> Name </label>
        <j-input
          id="name"
          v-model="$v.dataset_group_name.$model"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_form"/>
      </b-form-group>
      <div class="float-right">
        <b-button
          class="btn m__r--5"
          @click="closeModal">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="submitData">
          {{ !isUpdate ? 'Create' : 'Save' }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },
  data() {
    return {
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],

      dataset_group_id: 0,
      dataset_group_name: null,
      listGroup: [],
      isUpdate: false,
      popoverSelected: '',
      showPopover: false,
      showContainerGroup: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreJoana', ['group_data_list']),
  },
  watch: {
    dataset_group_name(val) {
      if (val) {
        const regexSymbol = /[^\w\s]/g;
        setTimeout(() => {
          this.dataset_group_name =
            val.toLowerCase()
              .replace(regexSymbol, '')
              .replace(' ', '_');
        }, 1);
      }
    },

    filter_data(val) {
      this.listGroup = this.group_data_list.filter(app => app.name.toUpperCase().includes(val.toUpperCase()) || app.id.toUpperCase().includes(val.toUpperCase()));
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    ...mapActions('jStoreJoana', ['getListDataGroup', 'createDataGroup', 'deleteDataGroup', 'updateDataGroup']),

    getListData() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: null,
        filter_operator: 'and',
      };
      this.getListDataGroup(req).then((res) => {
        if (res.data) {
          this.listGroup = res.data;
          this.showContainerGroup = true;
        }
      });
    },

    showPopoverComponent(id) {
      if (id !== this.popoverSelected) {
        this.popoverSelected = id;
        this.showPopover = true;
      } else {
        this.hideAllPopover();
      }
    },

    hideAllPopover() {
      this.popoverSelected = '';
      this.showPopover = false;
    },

    openConfig(data) {
      this.$root.$emit('bv::hide::popover', `configPopover-${data.id}`);
      this.dataset_group_id = data.id;
      this.dataset_group_name = data.name;
      this.$refs.modalAdd.show();
      this.isUpdate = true;
    },

    closeModal() {
      this.$refs.modalAdd.hide();
      this.dataset_group_id = 0;
      this.dataset_group_name = null;
      this.isUpdate = false;
      setTimeout(() => { this.$v.dataset_group_name.$reset(); }, 500);
    },

    submitData() {
      this.$v.dataset_group_name.$touch();
      if (!this.$v.dataset_group_name.$error) {
        if (this.isUpdate) {
          const param = {
            id: this.dataset_group_id,
            name: this.dataset_group_name,
          };
          this.updateDataGroup(param).then((res) => {
            if (!res.data.error) {
              this.closeModal();
              this.getListData();
            }
          });
        } else {
          this.createDataGroup({ name: this.dataset_group_name }).then((res) => {
            if (!res.data.error) {
              this.openDetail(res.data.id);
            }
          });
        }
      }
    },

    openDetail(id) {
      this.$router.push(`/joana/dataset/${id}`);
    },

    filter() {

    },

    deleteData(data) {
      this.$root.$emit('bv::hide::popover', `configPopover-${data.id}`);
      if (data.total_dataset === 0) {
        const text = 'Are you sure want to delete Dataset Group?';

        this.$swal({
          title: 'Delete',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.deleteDataGroup({ id: data.id }).then((res) => {
              this.getListData();
            });
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Dataset Already Exist, Can’t Delete Dataset Group');
      }
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
  validations() {
    return {
      dataset_group_name: { required },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/joanadb/jJoanaList.vue